import { styled, keyframes } from '@creditas-ui/react'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const InputIconSearch = styled.svg`
  width: 100%;
`

const InputIconSearchPath = styled.path`
  stroke: #1f2d27;
`

const InputIconSearchErasePath = styled.path`
  stroke: #1f2d27;
`

const Spinner = styled.div`
  display: flex;
  align-itens: center;
  justify-content: center;
  animation: ${rotate} 1s linear infinite;
`

export {
  InputIconSearch,
  InputIconSearchPath,
  InputIconSearchErasePath,
  Spinner,
}
